'use client';

import { useEffect } from 'react';

const ScrollToHashElement: React.FC = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const id = hash.substring(1);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return null;
};

const ScollToAnchor = () => {
  return (
    // <Suspense fallback={null}>use client
    <ScrollToHashElement />
    // </Suspense>
  );
};

export default ScollToAnchor;
